<template lang="pug">
head-meta(:title-page="titlePage",
  :description="descriptionPage" )
spinner(v-if="isLoading")
template(v-else)
  template(v-if="!isNotFound")
    //crumbs(:list="crumbs")
    category-cap(categoryName="Выбор дизайнеров", :current-page="currentPage")
    filters-line(
      v-if="filters.length"
      :filters-start="filters",
      :sort="sort",
      :products="products",
      :color-count="colorCount",
      :product-count="productCount",
      @sort-products="sortProducts",
      @apply-filters="applyFilters"
    )
    tile-line(
      :products="products",
      :current-page = "currentPage",
      :pages="pages",
      :is-loading-button="isLoadingButton"
      @show-more="showMore",
      @update-page="updatePage",
      @update-products="updateProducts"
    )
  thanks404(v-else, mod="error")
</template>

<script>
import Crumbs from '../components/Crumbs'
import CategoryCap from '../components/category/CategoryCap'
import { getProductsDesignersChoice, refreshDataWithProduct } from '../assets/scripts/Api'
import HeadMeta from '../components/_layout/HeadMeta'
import FiltersLine from '../components/FiltersLine'
import TileLine from '../components/_tiles/TileLine'
import Spinner from '../components/Spinner'
import Thanks404 from '../components/Thanks404'

export default {
  name: 'DesignersChoicePage',
  components: { Thanks404, TileLine, FiltersLine, HeadMeta, Crumbs, CategoryCap, Spinner },
  data () {
    return {
      products: [],
      filters: [],
      selectedFilters: {},
      crumbs: [{ route: { name: 'DesignersChoice' }, name: 'Выбор дизайнеров' }],
      currentPage: 1,
      pages: 1,
      sort: '',
      isLoading: false,
      isNotFound: false,
      isLoadingButton: false,
      startProducts: [],
      startPage: 1,
      productCount: 0
    }
  },
  computed: {
    titlePage () {
      if (this.isNotFound) return 'Страница не найдена'
      return this.currentPage > 1
        ? `Купить популярные товары для дома в Москве и Московской области - страница ${this.currentPage}`
        : 'Купить популярные товары для дома в Москве и Московской области'
    },
    descriptionPage () {
      if (this.isNotFound) return 'Проверьте ссылку на страницу, возможно она была удалена или перемещена'
      return this.currentPage > 1
        ? `Популярные товары в наличии и под заказ в магазине CHIEDOHOME. Доставка по Москве и Московской области ${this.currentPage}`
        : 'Купить популярные товары для дома в Москве и Московской области'
    },
    colorCount () {
      if (this.filters) {
        const colorFilters = this.filters.find(item => item.slug === 'tsvet')
        if (!colorFilters) return 0
        return colorFilters.list.filter(item => item.is_current).length
      }
      return 0
    }
  },
  methods: {
    async getDataPage (page) {
      this.isLoading = true
      const data = await getProductsDesignersChoice(page, this.sort, this.selectedFilters)
      if (!data || data.status === 'error') return await this.$router.push({ name: 'Error' })
      this.isLoading = false
      this.placeProductsData(data)
    },
    applyFilters (filters) {
      this.currentPage = 1
      this.selectedFilters = filters
      this.startProducts = []
      this.getDataPage()
    },
    sortProducts (sort) {
      this.sort = sort
      this.refreshProducts()
    },
    refreshProducts () {
      if (this.currentPage === 1) {
        this.$router.push({ name: this.$route.name, params: { page: '', numberPage: '' }, query: { sort: this.sort } })
      } else {
        this.$router.push({ name: this.$route.name, params: { page: 'page', numberPage: this.currentPage }, query: { sort: this.sort } })
      }
    },
    isNeedErrorRedirect (to) {
      const page = to.params.page
      const number = to.params.numberPage
      if ((page && !number) || (!page && number)) {
        this.isNotFound = true
        return true
      }
      return false
    },
    placeProductsData (data) {
      if (data.status === 'error') this.isNotFound = true
      this.products = data.products
      this.filters = data.filters
      this.currentPage = data.page || 1
      this.pages = data.page_count
      this.productCount = data.products_count
      if (!this.startProducts.length) {
        this.startProducts = this.products
        this.startPage = this.currentPage
      }
    },
    async showMore (page) {
      this.isLoadingButton = true
      const data = await getProductsDesignersChoice(page, this.sort, this.selectedFilters)
      this.isLoadingButton = false
      this.currentPage = page
      this.products = [...this.products, ...data.products]
      const url = this.sort ? `/designers-choice/page/${page}?sort=${this.sort}` : `/designers-choice/page/${page}`
      history.replaceState(history.state, '', url)
    },
    updatePage (path) {
      if (path === this.$route.fullPath) {
        history.replaceState(history.state, '', path)
        this.products = this.startProducts
        this.currentPage = this.startPage
      } else {
        this.startProducts = []
        this.startPage = 1
      }
    },
    async updateProducts (categorySlug) {
      await refreshDataWithProduct(categorySlug)
    }
  },
  mounted () {
    if (this.isNeedErrorRedirect(this.$route)) return
    if (this.$route.params.numberPage) this.currentPage = +this.$route.params.numberPage
    if (this.$route.query.sort) this.sort = this.$route.query.sort
    this.getDataPage(this.currentPage)
  },
  async beforeRouteUpdate (to, from, next) {
    this.isNotFound = false
    if (this.isNeedErrorRedirect(to)) return
    if (to.query.sort !== from.query.sort) this.startProducts = []
    to.params.numberPage ? await this.getDataPage(+to.params.numberPage) : await this.getDataPage()
    next()
  }
}
</script>
